export const RAW_BASE_URL = process.env.REACT_APP_RAW_BASE_URL || '192.168.0.103:8000';
export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://balapan.herokuapp.com';

// OpenAI Configuration (for testing only - move to backend for production)
export const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY || 'your-api-key-here';
// export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://192.168.200.100:8000';